// extracted by mini-css-extract-plugin
module.exports = {"container":"Perpetrator_container___lDMi","page":"Perpetrator_page__BPCXo","section":"Perpetrator_section__UOF3Z"};